import siteImages from "../data/siteImages.json";

export const PRIMARY_SITE_ORIGIN = "https://lukkey.com";

export const getAbsoluteUrl = (origin, path) => {
  if (!path) return origin;
  if (/^https?:\/\//i.test(path)) return path;
  return new URL(path, origin).toString();
};

export const getSeoImagesForPage = (
  pagePath,
  origin = PRIMARY_SITE_ORIGIN,
) => {
  const pageUrl = getAbsoluteUrl(origin, pagePath);

  return siteImages
    .filter((image) => image.pagePath === pagePath)
    .map((image) => ({
      ...image,
      pageUrl,
      src: getAbsoluteUrl(origin, image.src),
    }));
};

export const getPrimarySeoImage = (images = []) =>
  images.find((image) => image.representativeOfPage) || images[0] || null;

export const buildImageObjectSchemas = (images = []) =>
  images.map((image) => ({
    "@context": "https://schema.org",
    "@type": "ImageObject",
    "@id": `${image.pageUrl}#${image.id}`,
    url: image.src,
    contentUrl: image.src,
    encodingFormat: image.encodingFormat || "image/webp",
    name: image.title,
    description: image.caption || image.alt,
    caption: image.caption || image.alt,
    width: image.width,
    height: image.height,
    keywords: Array.isArray(image.keywords) ? image.keywords.join(", ") : undefined,
    inLanguage: "en",
    about: Array.isArray(image.keywords)
      ? image.keywords.map((keyword) => ({
          "@type": "Thing",
          name: keyword,
        }))
      : undefined,
    creator: {
      "@type": "Organization",
      name: "LUKKEY",
    },
    publisher: {
      "@type": "Organization",
      name: "LUKKEY",
      url: PRIMARY_SITE_ORIGIN,
    },
    creditText: "LUKKEY",
    copyrightNotice: "LUKKEY",
    representativeOfPage: Boolean(image.representativeOfPage),
    mainEntityOfPage: image.pageUrl,
  }));

export const buildImageGallerySchema = ({
  pageUrl,
  pageTitle,
  images = [],
}) => {
  if (!images.length) return null;

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: `${pageTitle} image gallery`,
    itemListOrder: "https://schema.org/ItemListOrderAscending",
    numberOfItems: images.length,
    mainEntityOfPage: pageUrl,
    itemListElement: images.map((image, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: image.src,
      item: {
        "@type": "ImageObject",
        "@id": `${pageUrl}#${image.id}`,
        url: image.src,
        contentUrl: image.src,
        encodingFormat: image.encodingFormat || "image/webp",
        name: image.title,
        description: image.caption || image.alt,
        caption: image.caption || image.alt,
        width: image.width,
        height: image.height,
      },
    })),
  };
};
